import activity from "@/assets/lottie/hero-section/activities.json";
import esim from "@/assets/lottie/hero-section/esim.json";
import flight from "@/assets/lottie/hero-section/flight.json";
import hotel from "@/assets/lottie/hero-section/hotel.json";
// import moreService from "@/assets/lottie/hero-section/more-service.json";
// import privateTaxi from "@/assets/lottie/hero-section/private-taxi.json";
import rental from "@/assets/lottie/hero-section/rentals.json";
import spa from "@/assets/lottie/hero-section/spas-massage.json";
import type {
  IntegrationLinkKey,
  ServiceKey,
} from "@/utils/constants/services/serviceCatalog";
import type { SearchServiceKey } from "@/components/search-form/search.modules.type";
import type { WebConfigMenuKey } from "@/types/core";

export type BaseServiceItem = {
  key: ServiceKey;
  label: string;
  iconSrc?: object;
  remoteConfigKey?: WebConfigMenuKey | string;
  mobileOnly?: boolean;
  headerOnly?: boolean;
};

export type InternalMainServiceItem = BaseServiceItem & {
  href: string;
  selectValue?: SearchServiceKey | string;
  integrationKey?: never;
};

export type IntegrationMainServiceItem = BaseServiceItem & {
  integrationKey: IntegrationLinkKey;
  href?: never;
  selectValue?: never;
};

export type StaticMainServiceItem = BaseServiceItem & {
  href?: never;
  selectValue?: never;
  integrationKey?: never;
};

export type MainServiceItemData =
  InternalMainServiceItem | IntegrationMainServiceItem | StaticMainServiceItem;

export const isInternalMainServiceItem = (
  item: MainServiceItemData,
): item is InternalMainServiceItem => "href" in item && Boolean(item.href);

export const isIntegrationMainServiceItem = (
  item: MainServiceItemData,
): item is IntegrationMainServiceItem => "integrationKey" in item;

export const mainServiceItems: MainServiceItemData[] = [
  {
    key: "hotels",
    label: "Accommodation",
    iconSrc: hotel,
    remoteConfigKey: "hotel",
    href: "/hotels",
    selectValue: "hotels",
  },
  {
    key: "rentals",
    label: "Rentals",
    iconSrc: rental,
    remoteConfigKey: "rental",
    href: "/rentals",
    selectValue: "rentals",
  },
  {
    key: "spa_msg",
    label: "Spas & Massages",
    iconSrc: spa,
    remoteConfigKey: "spa_msg",
    href: "/spa-msg",
    selectValue: "spa_msg",
  },
  {
    key: "tour_act",
    label: "Activities",
    iconSrc: activity,
    remoteConfigKey: "tour_act",
    href: "/tour-act",
    selectValue: "tour_act",
  },
  {
    key: "flights",
    label: "Flights",
    iconSrc: flight,
    remoteConfigKey: "flight",
    integrationKey: "bookmefly",
  },
  {
    key: "esim",
    label: "eSim",
    iconSrc: esim,
    remoteConfigKey: "esim",
    integrationKey: "knowroaming",
  },
  {
    key: "discover",
    label: "Discover",
    remoteConfigKey: "discover",
    href: "/discover",
    headerOnly: true,
  },
  // {
  //   key: "private_taxi",
  //   label: "Private Taxi",
  //   iconSrc: privateTaxi,
  //   remoteConfigKey: "taxi",
  //   mobileOnly: true,
  // },
  // {
  //   key: "other_service",
  //   label: "Other Service",
  //   iconSrc: moreService,
  //   mobileOnly: true,
  // },
];

export const heroServiceItems = mainServiceItems.filter(
  (item) => !item.headerOnly && !item.mobileOnly,
);

export const headerNavItems = mainServiceItems.filter(
  (item) => !item.mobileOnly,
);
